import Typography from "@mui/material/Typography";

const GeneralError = () => {
    return (
        <>
            <Typography variant="h2">Oops!</Typography>
            <Typography>Sorry, the page failed to load.</Typography>
            <Typography>Please refresh the page and try again.</Typography>
        </>
    );
};

export default GeneralError;